let CMS_API_BASE_URL = process.env.REACT_APP_CMS_SERVICE;
let GATEWAY_BASE_URL = process.env.REACT_APP_GATEWAY_SERVICE;
let GATEWAY_BASE_URL_V2 = process.env.REACT_APP_GATEWAY_SERVICE_V2;
let VOICE_AGENT_URL = "https://voice-agent.moglix.com";
let VOICE_AGENT_URL_V2 = 'http://localhost:5000'
// let GATEWAY_BASE_URL_V3 = 'https://api-gt-uat.moglix.com/api/uat';
let AI_UTILITY_BASE_URL = process.env.REACT_APP_AI_UTILITY_SERVICE;
let AI_UTILITY_BASE_URL_V2 = 'https://ai-utility-uat.moglix.com';
let CMS_READ_BASE_URL = process.env.REACT_APP_CMS_READ_SERVICE || 'https://cmsread.moglilabs.com';

export const apis = {
  LOGIN_WITH_MICROSOFT: `${CMS_API_BASE_URL}/cmsApi/v1/auth/login/microsoft`,

  GET_ARTICLE_CATEGORY_ID: `${GATEWAY_BASE_URL}/nodeApi/v1/category/getcategorybyid?catId=`,
  CREATE_ARTICLE: `${CMS_API_BASE_URL}/cmsApi/v1/article/createArticle`,
  GET_ARTICLE_LISTING: `${CMS_API_BASE_URL}/cmsApi/v1/article/getArticles?`,
  GET_ARTICLE_LISTING_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/article/getArticle/`,
  PUBLISH_ARTICLE: `${CMS_API_BASE_URL}/cmsApi/v1/article/publishArticle?`,
  UPDATE_ARTICLE: `${CMS_API_BASE_URL}/cmsApi/v1/article/updateArticle`,
  DELETE_ARTICLE_LIST: `${CMS_API_BASE_URL}/cmsApi/v1/article/deleteArticle/`,

  GET_LAYOUT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getLayoutById/`,
  GET_LAYOUTS: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getLayouts?`,
  CREATE_LAYOUT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/createLayout`,
  UPDATE_LAYOUT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/updateLayout`,
  DELETE_LAYOUT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/deleteLayoutById/`,
  CLONE_LAYOUT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/cloneLayoutById/`,
  GET_STATIC_FORM_FIELDS: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getStaticFormFields`,
  CREATE_COMPONENT_V2: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/createComponentV2`,
  GET_COMPONENT_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getComponentById?`,
  GET_POPULATED_LAYOUT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getPopulatedLayout/`,
  UPDATE_COMPONENT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/updateComponent`,
  UPDATE_COMPONENT_STATUS: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/updateStatusOfComponent`,
  GET_COMPONENTS: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getComponents?`,
  COPY_COMPONENT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/copyComponent`,
  SET_LAYOUT_JSON_BY_LAYOUT_CODE: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getLayoutJsonByLayoutCode?`,
  DELETE_COMPONENT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/hardDeleteComponentById/`,
  GET_POPULATED_COMPONENT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/getPopulatedComponent/`,
  GET_LAYOUT_JSON_BY_REQUEST_PARAM: `${GATEWAY_BASE_URL_V2}/cms/getLayoutJsonByRequestParam?requestParam=`,
  CREATE_ELEMENT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/createElement`,
  UPDATE_ELEMENT_STATUS: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/updateStatusofElement`,
  UPDATE_ELEMENT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/updateAttributesOfElement`,
  DELETE_ELEMENT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/hardDeleteElementById/`,

  CLEAR_CACHE: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/clearCache?`,
  CLEAR_CACHE_BY_LAYOUT: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/clearCacheByLayout?`,
  UPLOAD_IMAGE: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/uploadImage`,
  CONVERT_TO_WEBP: `${GATEWAY_BASE_URL_V2}/common/convertToWebp`,
  UPLOAD_FILE: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/uploadFile`,

  GET_CAMPAIGNS: `${CMS_API_BASE_URL}/cmsApi/v1/adsense/searchCampaign`,
  GET_LOOKUPS: `${CMS_API_BASE_URL}/cmsApi/v1/adsense/getLookups?`,
  GET_BRANDS: `${GATEWAY_BASE_URL_V2}/search/getAllBrands`,
  GET_CAMPAIGN: `${CMS_API_BASE_URL}/cmsApi/v1/adsense/getCampaignById/`,
  CREATE_CAMPAIGN: `${CMS_API_BASE_URL}/cmsApi/v1/adsense/createCampaign`,
  UPDATE_CAMPAIGN_STATUS: `${CMS_API_BASE_URL}/cmsApi/v1/adsense/updateStatusOfCampaign?`,
  GET_CATEGORIES: `${GATEWAY_BASE_URL}/nodeApi/v1/search/getAllCategoriesV2`,

  //TODO: make it configurable
  GET_SEGREGATED_CATEGORIES: `${GATEWAY_BASE_URL_V2}/search/getSegregatedCategories?`,
  GET_SEGREGATED_CATEGORIES_IN_BULK: `${GATEWAY_BASE_URL_V2}/search/getSegregatedCategoriesInBulk`,
  GET_BRANDS_BY_CATEGORYIDS: `${GATEWAY_BASE_URL_V2}/search/getBrandsByCategoryIds`,

  GET_BRANDS_BY_CATEGORY: `${GATEWAY_BASE_URL_V2}/search/getBrandsByCategoryIds`,

  FETCH_PRODUCT_BY_BRAND_CATEGORY: `${GATEWAY_BASE_URL_V2}/search/fetchProductsByCategoryAndBrand?`,

  DOWNLOAD_FILE: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/downloadFile?fileUrl=`,
  DELETE_FILE: `${CMS_API_BASE_URL}/cmsApi/v1/cms/layout/deleteFile?fileName=`,
  DELAY_COMMUNICATION_VIA_WHATSAPP: `${AI_UTILITY_BASE_URL}/api/whatsapp-helper/delay-communication`,
  SUPPLIER_SUPPORT_VIA_WHATSAPP: `${GATEWAY_BASE_URL_V2}/analytic/executeEvent`,
  GET_REVIEWS: `${CMS_API_BASE_URL}/cmsApi/v1/reviews/getReviews?`,
  UPDATE_REVIEW: `${CMS_API_BASE_URL}/cmsApi/v1/reviews/updateReview`,
  DOWNlOAD_REVIEWS: `${CMS_API_BASE_URL}/cmsApi/v1/reviews/download/?email=`,
  UPLOAD_REVIEWS: `${CMS_API_BASE_URL}/cmsApi/v1/reviews/updateReviews?`,
  REVIEW_REPLY: `${CMS_API_BASE_URL}/cmsApi/v1/reviews/reviewReply`,
  GENERATE_PRESIGNED_URL: `${GATEWAY_BASE_URL_V2}/review/generateUploadUrl`,

  UPLOAD_PRODUCT_DESCRIPTION: `${CMS_API_BASE_URL}/cmsApi/v1/util/generateProductDescription`,
  DOWNLOAD_PRODUCT_DESCRIPTION: `${CMS_API_BASE_URL}/cmsApi/v1/util/downloadProductDescription/`,
  TRACK_PRODUCT_DESCRIPTION: `${CMS_API_BASE_URL}/cmsApi/v1/util/trackProductDescription/`,

  GET_LIST_OF_BRAND_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/getBrandBlocks?`,
  DELETE_BRAND_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteBrandBlock/`,
  DELETE_BRAND_BLOCK_ELEMENT: `${CMS_API_BASE_URL}/api/cms/block/deleteBrandBlockElement/`,
  CREATE_BRAND_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createBrandBlock`,
  GET_BRAND_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getBrandBlockById/`,
  UPDATE_BRAND_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateBrandBlock/`,

  GET_LIST_OF_CATEGORY_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/getCategoryBlocks?`,
  CREATE_CATEGORY_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createCategoryBlock`,
  GET_CATEGORY_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getCategoryBlockById/`,
  UPDATE_CATEGORY_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateCategoryBlock/`,
  DELETE_CATEGORY_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteCategoryBlock/`,
  DELETE_CATEGORY_BLOCK_ELEMENT: `${CMS_API_BASE_URL}/api/cms/block/deleteCategoryBlockElement/`,

  GET_STATIC_HTML_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/getHtmlBlocks?`,
  CREATE_STATIC_HTML_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createHtmlBlock`,
  GET_STATIC_HTML_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getHtmlBlockById/`,
  UPDATE_STATIC_HTML_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateHtmlBlock/`,
  DELETE_STATIC_HTML_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteHtmlBlock/`,

  GET_LIST_OF_IMAGE_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/getImageBlocks?`,
  CREATE_IMAGE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createImageBlock`,
  UPDATE_IMAGE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateImageBlock/`,
  DELETE_IMAGE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteImageBlock/`,
  GET_IMAGE_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getImageBlockById/`,
  DELETE_IMAGE_BLOCK_ELEMENT: `${CMS_API_BASE_URL}/api/cms/block/deleteImageBlockElement/`,

  GET_PRODUCT_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/getProductBlocks?`,
  CREATE_PRODUCT_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createProductBlock`,
  GET_PRODUCT_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getProductBlockById/`,
  UPDATE_PRODUCT_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateProductBlock/`,
  DELETE_PRODUCT_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteProductBlock/`,
  DELETE_PRODUCT_BLOCK_ELEMENT: `${CMS_API_BASE_URL}/api/cms/block/deleteProductBlockElement/`,
  PRODUCT_BLOCK_UPLOAD_CSV_FILE: `${CMS_API_BASE_URL}/api/cms/block/productBlock/uploadCsvfile/`,

  GET_GENERAL_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/generalBlocks?`,
  CREATE_GENERAL_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createGeneralBlock`,
  GET_GENERAL_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getGeneralBlock/`,
  UPDATE_GENERAL_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateGeneralBlock/`,
  DELETE_GENERAL_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteGeneralBlock/`,
  DELETE_GENERAL_BLOCK_ELEMENT: `${CMS_API_BASE_URL}/api/cms/block/deleteGeneralBlockElement/`,

  GET_TEMPLATE_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/templateBlocks?`,
  CREATE_TEMPLATE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createTemplateBlock`,
  GET_TEMPLATE_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getTemplateBlock/`,
  UPDATE_TEMPLATE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateTemplateBlock/`,
  DELETE_TEMPLATE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteTemplateBlock/`,
  DELETE_TEMPLATE_BLOCK_ELEMENT: `${CMS_API_BASE_URL}/api/cms/block/deleteTemplateBlockElement/`,

  GET_BLOCK_TYPE_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/blockTypes?`,
  CREATE_BLOCK_TYPE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/createBlockType`,
  GET_BLOCK_TYPE_BLOCK_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/getBlockType/`,
  UPDATE_BLOCK_TYPE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/updateBlockType/`,
  DELETE_BLOCK_TYPE_BLOCK: `${CMS_API_BASE_URL}/api/cms/block/deleteBlockType/`,

  GET_BLOCK_LAYOUTS: `${CMS_API_BASE_URL}/api/cms/block/layouts?`,
  GET_BLOCK_LAYOUT_BY_ID: `${CMS_API_BASE_URL}/api/cms/block/layout/`,
  CREATE_BLOCK_LAYOUT: `${CMS_API_BASE_URL}/api/cms/block/createLayout`,
  UPDATE_BLOCK_LAYOUT: `${CMS_API_BASE_URL}/api/cms/block/updateLayout/`,
  CLONE_BLOCK_LAYOUT: `${CMS_API_BASE_URL}/api/cms/block/layout/clone/`,
  GET_BLOCK_LAYOUT_TEMPLATES: `${CMS_API_BASE_URL}/api/cms/block/dropdown/getLayoutTemplates`,
  GET_BLOCK_LAYOUT_GROUP: `${CMS_API_BASE_URL}/api/cms/block/dropdown/getLayoutGroups`,
  GET_BLOCK_BLOCK_TYPES: `${CMS_API_BASE_URL}/api/cms/block/dropdown/getBlockTypes`,
  GET_BLOCK_BLOCKS: `${CMS_API_BASE_URL}/api/cms/block/dropdown/getBlocks/`,
  DELETE_BLOCK_LAYOUT_ELEMENT: `${CMS_API_BASE_URL}/api/cms/block/deleteLayoutBlockElement/`,

  BLOCK_CUSTOMER: `${GATEWAY_BASE_URL}/nodeApi/v1/address/deactivateUser`,

  GET_FBTS: `${CMS_API_BASE_URL}/cmsApi/v1/fbt/getFbts?`,
  GET_FBT_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/fbt/getFbt/`,
  UPLOAD_FBT_FILE: `${CMS_API_BASE_URL}/cmsApi/v1/fbt/uploadFbts?`,
  DOWNLOAD_FBT_DUMP: `${CMS_API_BASE_URL}/cmsApi/v1/fbt/downloadDump?`,
  UPDATE_FBT: `${CMS_API_BASE_URL}/cmsApi/v1/fbt/updateFbt`,
  CREATE_FBT: `${CMS_API_BASE_URL}/cmsApi/v1/fbt/createFbt`,

  GET_FAQS: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/getCategorySchemaList?`,
  GET_FAQ: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/getCategorySchemaDetails?`,
  CREATE_FAQ: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/createCategorySchema`,
  DELETE_FAQ_SCHEMA: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/deleteCategorySchema`,
  DOWNLOAD_FAQ_DUMP: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/downloadAllSchema`,

  GET_ATTRIBUTES: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/getAttributesListings?`,
  GET_ATTRIBUTE_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/getAttributesListing/`,
  GET_ATTRIBUTE: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/getAttributesListing/`,
  CREATE_ATTRIBUTE: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/createAttributesListing`,
  UPDATE_ATTRIBUTE: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/updateAttributesListing`,
  DELETE_ATTRIBUTE_SCHEMA: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/deleteAttributesListing/`,
  DOWNLOAD_ATTRIBUTE_DUMP: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/downloadDump?`,
  BULK_UPLOAD_ATTRIBUTE: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/uploadAlps?`,
  GET_PRODUCT_COUNT: `${CMS_API_BASE_URL}/cmsApi/v1/attributeListing/getProductCount`,

  GET_SERVICEABILITY: `${CMS_API_BASE_URL}/v2/serviceability/getServiceabilityList?`,
  GET_QNA_LIST: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/getQuestionsList?`,
  ADD_UPDATE_ANSWER: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/addAnswer/`,
  PUBLISH_QUESTIONS: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/publishQuestion`,
  DISABLE_QUESTIONS: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/disableQuestions`,
  DOWNLOAD_QUESTIONS: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/downloadCSV?`,
  BULK_INSERT_QA: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/cms/questions/bulk/InsertQA`,
  BULK_PUBLISH_QA: `${CMS_API_BASE_URL}/cmsApi/v1/feedback/cms/questions/bulk/publish`,
  UPLOAD_SERVICEABILITY_FILE: `${CMS_API_BASE_URL}/v2/serviceability/upload?`,
  DOWNLOAD_SERVICEABILITY: `${CMS_API_BASE_URL}/v2/serviceability/download?`,
  BULK_CREATE_SERVICEABILITY: `${CMS_API_BASE_URL}/v2/serviceability/bulk-create`,

  GET_PART_PAYMENT_PRODUCTS: `${CMS_API_BASE_URL}/payment/v1/partialPayment/product-list?`,
  UPLOAD_PART_PAYMENT_FILE: `${CMS_API_BASE_URL}/payment/v1/partialPayment/product-upload?`,
  DOWNLOAD_PART_PAYMENT: `${CMS_API_BASE_URL}/payment/v1/partialPayment/product-download?`,

  GET_ALL_TAGS: `${CMS_API_BASE_URL}/cmsApi/v1/productTagging/getAllTags`,
  GET_TAG_DETAILS: `${CMS_API_BASE_URL}/cmsApi/v1/productTagging/getTagDetails?tagId=`,
  UPLOAD_TAG_IMAGE: `${CMS_API_BASE_URL}/cmsApi/v1/productTagging/uploadImage`,
  CREATE_PRODUCT_TAG: `${CMS_API_BASE_URL}/cmsApi/v1/productTagging/createProductTag`,
  UPDATE_PRODUCT_TAG: `${CMS_API_BASE_URL}/cmsApi/v1/productTagging/updateTagDetails`,

  GET_LIST_OF_PLA_FEEDS: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/getPlaFeeds?`,
  CREATE_PLA_FEED: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/createPlaFeed`,
  GET_PLA_FEED_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/getPlaFeed/`,
  UPDATE_PLA_FEED: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/updatePlaFeed/`,
  BULK_PLA_FILE: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/uploadPlaFeeds?`,
  DOWNLOAD_PLA_DUMP: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/downloadDump?`,
  GET_PLA_AUDIT_HISTORY: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/getAuditHistory/`,
  GET_PLA_UPLOAD_STATUS: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/getUploadStatus?`,
  GET_PLA_ALL_BATCHES: `${CMS_API_BASE_URL}/cmsApi/v1/plaFeed/getAllBatches?`,

  GET_PAGEMAPPING_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/requestMapping/getRequestMappings/`,
  GET_PAGEMAPPINGS: `${CMS_API_BASE_URL}/cmsApi/v1/requestMapping/getRequestMappings?`,
  GET_PAGEMAPPING: `${CMS_API_BASE_URL}/cmsApi/v1/requestMapping/getRequestMappings/`,
  CREATE_PAGEMAPPING: `${CMS_API_BASE_URL}/cmsApi/v1/requestMapping/createRequestMapping`,
  UPDATE_PAGEMAPPING: `${CMS_API_BASE_URL}/cmsApi/v1/requestMapping/updateRequestMapping`,
  DELETE_PAGEMAPPING_SCHEMA: `${CMS_API_BASE_URL}/cmsApi/v1/requestMapping/deleteRequestMapping`,

  GET_BOOKINGS: `${CMS_API_BASE_URL}/api/mexpress/searchBookings`,
  UPDATE_BOOKING_STATUS: `${CMS_API_BASE_URL}/api/mexpress/updateBookingStatus`,
  FETCH_ALL_CITIES: `${CMS_API_BASE_URL}/api/mexpress/fetchAllCities`,

  GET_DISTINCT_CATEGORY_CODE_BY_MSNS: `${GATEWAY_BASE_URL_V2}/search/getDistinctCategoryCodeByMsns`,

  //CMS READ
  CREATE_LANDING_PAGE: `${CMS_API_BASE_URL}/api/cmsread/landingPage/create`,
  GET_LANDING_PAGES: `${CMS_API_BASE_URL}/api/cmsread/landingPage/get?`,
  UPDATE_LANDING_PAGE: `${CMS_API_BASE_URL}/api/cmsread/landingPage/update/`,
  GET_LANDING_PAGE_BY_ID: `${CMS_API_BASE_URL}/api/cmsread/landingPage/getById/`,

  // Product Pricing APIs
  FETCH_PRODUCT_PRICING: `${CMS_API_BASE_URL}/api/priceengine/fetch-product-pricing`,
  FETCH_NDD_SUPPLIER_PRICE_HISTORY: `${CMS_API_BASE_URL}/api/address/fetch-ndd-msn-supplier-price-history`,
  FETCH_NDD_SUPPLIER: `${CMS_API_BASE_URL}/api/address/fetch-ndd-msn-supplier`,
  FETCH_PRODUCT_PRICING_HISTORY: `${CMS_API_BASE_URL}/api/priceengine/fetch-product-pricing-history`,
  UPLOAD_PRODUCT_PRICING: `${CMS_API_BASE_URL}/api/priceengine/update/offerPrice`,
  UPLOAD_NDD_OFFER_PRICE: `${CMS_API_BASE_URL}/api/priceengine/bulk-upload-ndd-offer-price`,
  UPLOAD_NDD_SUPPLIER: `${CMS_API_BASE_URL}/api/address/bulk-upload-ndd-msn-supplier`,
  FLASH_DEAL_LIST: `${CMS_API_BASE_URL}/api/priceengine/product-offer-pricing/list`,
  FLASH_DEAL_CREATE: `${CMS_API_BASE_URL}/api/priceengine/product-offer-pricing/create`,
  FLASH_DEAL_UPDATE: `${CMS_API_BASE_URL}/api/priceengine/product-offer-pricing/update`,
  UPLOAD_FLASH_DEAL: `${CMS_API_BASE_URL}/api/priceengine/product-offer-pricing/bulk-upload`,


  // Cache Management APIs
  PURGE_CACHE_STORE_PAGE: `${CMS_API_BASE_URL}/api/cms/purge-cache/store-page`,
  PURGE_CACHE_BRAND_CATEGORY: `${CMS_API_BASE_URL}/api/search/purge-cache/brand-category`,

  GET_ORDER_CHATBOT_ANALYTICS: `${CMS_API_BASE_URL}/api/ai-utility/order-chatbot/analytics/widget/total-chats`,
  GET_CHATBOT_CONVERSATIONS: `${CMS_API_BASE_URL}/api/ai-utility/order-chatbot/analytics/conversations`,

  LIST_PROMPTS: `${CMS_API_BASE_URL}/api/ai-utility/prompt-management/list-prompts`,
  GET_PROMPT: `${CMS_API_BASE_URL}/api/ai-utility/prompt-management/get-prompt/`,
  UPSERT_PROMPT: `${CMS_API_BASE_URL}/api/ai-utility/prompt-management/upsert-prompt`,

  FETCH_WHATSAPP_CHAT_HISTORY: `${AI_UTILITY_BASE_URL}/api/whatsapp-helper/fetch-chat-history`,
  FETCH_WHATSAPP_DASHBOARD: `${AI_UTILITY_BASE_URL}/api/whatsapp-helper/chat-history-dashboard`,
  FETCH_WHATSAPP_SUMMARY: `${AI_UTILITY_BASE_URL}/api/whatsapp-helper/chat-history-summary`,
  FETCH_WHATSAPP_REPORT: `${AI_UTILITY_BASE_URL}/api/reports/whatsapp-chats-report-v2`,
  DOWNLOAD_WHATSAPP_DAILY_REPORT: `${AI_UTILITY_BASE_URL}/api/reports/download-whatsapp-chatbot-report`,

  FETCH_PRODUCT_CHAT_HISTORY: `${CMS_API_BASE_URL}/api/ai-utility/genai/reports`,

  FETCH_OTP_ANALYTICS: `${GATEWAY_BASE_URL_V2}/auth/otpAnalytics`,

  // User Journey Analytics APIs
  FETCH_USER_JOURNEYS: `${CMS_API_BASE_URL}/api/user-journey/analytics`,
  FETCH_FRESHDESK_TICKETS: `${CMS_API_BASE_URL}/api/freshdesk/tickets`,
  FETCH_USER_PERSONA: `${CMS_API_BASE_URL}/api/user-journey/persona`,
  FETCH_WHATSAPP_INTERACTIONS: `${CMS_API_BASE_URL}/api/whatsapp/interactions`,

  UPDATE_CUSTOMER_PAYMENT_MODE: `${CMS_API_BASE_URL}/api/address/update-customer-payment-mode`,

  // SUPPLIER STOCK ALERTS
  GET_SUPPLIER_STOCK_ALERTS: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts`,
  UPDATE_PROMISE_DATE: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/update-promise-date`,
  UPDATE_ACTION_ALERT: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/update-action`,
  UPDATE_REASON_ALERT: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/update-reason`,
  UPDATE_AGENT_ALERT: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/update-agent`,
  UPDATE_NOTE_ALERT: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/update-note`,
  GET_ALERT_CATEGORIES: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/categories?oos=true`,
  GET_ALERT_ACTIONS: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/actions`,
  GET_ALERT_REASONS: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/reasons`,
  GET_ALERT_AGENTS: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/agents`,
  DOWNLOAD_SUPPLIER_STOCK_ALERTS: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/download`,
  GET_STOCK_ALERT_HISTORY: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/history`,
  REFRESH_STOCK_ALERTS: `${CMS_API_BASE_URL}/api/cms/supplier-stock-alerts/prepare-top-msns-alert-data`,

  // USER MANAGEMENT APIs
  USER_MANAGEMENT_LIST: `${CMS_API_BASE_URL}/api/cms/user-management/user-list`,
  USER_MANAGEMENT_GET_USER: `${CMS_API_BASE_URL}/api/cms/user-management/user`,
  USER_MANAGEMENT_CREATE_USER: `${CMS_API_BASE_URL}/api/cms/user-management/create-user`,
  USER_MANAGEMENT_UPDATE_USER: `${CMS_API_BASE_URL}/api/cms/user-management/update-user`,
  USER_MANAGEMENT_ROLE_LIST: `${CMS_API_BASE_URL}/api/cms/user-management/role-list`,
  USER_MANAGEMENT_CREATE_ROLE: `${CMS_API_BASE_URL}/api/cms/user-management/create-role`,
  USER_MANAGEMENT_UPDATE_ROLE: `${CMS_API_BASE_URL}/api/cms/user-management/update-role`,

  FETCH_USER: `${AI_UTILITY_BASE_URL}/api/order-chatbot/tool/fetch-user`,
  FETCH_USER_ORDERS: `${AI_UTILITY_BASE_URL}/api/order-chatbot/tool/fetch-user-orders`,

  FRESHDESK_TICKETS_LIST: `${AI_UTILITY_BASE_URL}/api/freshdesk/tickets/list`,
  FRESHDESK_TICKETS_DASHBOARD: `${AI_UTILITY_BASE_URL}/api/freshdesk/tickets/dashboard-summary`,
  FRESHDESK_TICKET_DETAILS: `${AI_UTILITY_BASE_URL}/api/freshdesk/tickets/details`,
  FRESHDESK_ESCALATIONS_GROUPED: `${AI_UTILITY_BASE_URL}/api/freshdesk/tickets/recent-open-pending-grouped`,
  FRESHDESK_API_CALLS_ANALYTICS: `${AI_UTILITY_BASE_URL}/api/freshdesk/api-calls/analytics`,
  GENAI_COST_ANALYTICS: `${AI_UTILITY_BASE_URL}/api/genai/usage/cost-analytics`,


  OZONETEL_LIVE_REPORT_FILTERS: `${AI_UTILITY_BASE_URL}/api/ozonetel/live_report/filters`,
  OZONETEL_LIVE_REPORT: `${AI_UTILITY_BASE_URL}/api/ozonetel/live_report/list`,
  OZONETEL_LIVE_REPORT_DOWNLOAD: `${AI_UTILITY_BASE_URL}/api/ozonetel/live_report/download`,
  OZONETEL_LIVE_REPORT_DETAILS: `${AI_UTILITY_BASE_URL}/api/ozonetel/live_report/details`,
  OZONETEL_DASHBOARD_API: `${AI_UTILITY_BASE_URL}/api/ozonetel/dashboard/api`,
  OZONETEL_VOICE_AI_AGENT: `${AI_UTILITY_BASE_URL}/api/ozonetel/voice_ai_agent/list`,
  OZONETEL_VOICE_AI_AGENT_DETAILS: `${AI_UTILITY_BASE_URL}/api/ozonetel/voice_ai_agent/details`,
  OZONETEL_ANALYZE_CALL_AUDIO: `${AI_UTILITY_BASE_URL}/api/ozonetel/analyze-call-audio`,
  OZONETEL_AGENT_LEADERBOARD: `${AI_UTILITY_BASE_URL}/api/ozonetel/agent-leaderboard`,
  OZONETEL_QUEUE_COUNT: `${AI_UTILITY_BASE_URL}/api/ozonetel/audio-analysis-queue/count`,
  OZONETEL_CSAT_DETAILS: `${AI_UTILITY_BASE_URL}/api/ozonetel/csat/details`,

  AGENT_NOTES_GET: `${AI_UTILITY_BASE_URL}/api/crm/agent-notes`,
  AGENT_NOTES_CREATE: `${AI_UTILITY_BASE_URL}/api/crm/agent-notes`,
  AGENT_NOTES_UPDATE: `${AI_UTILITY_BASE_URL}/api/crm/agent-notes`,
  CRM_USER_TIMELINE: `${AI_UTILITY_BASE_URL}/api/crm/user-timeline`,
  CHECK_CUSTOMER_PRIORITY_ORDERS: `${AI_UTILITY_BASE_URL}/api/util/check-if-customer-orders-are-priority`,
  FETCH_ORDER_ITEM_HISTORY: `${GATEWAY_BASE_URL_V2}/order/fetchOrderItemHistory`,

  RFQ_CARE_USER_SESSIONS: `${AI_UTILITY_BASE_URL}/api/rfq-care/user-sessions`,
  RFQ_CARE_SIMULATE_MESSAGE: `${AI_UTILITY_BASE_URL}/api/rfq-care/message`,

  // Samaira RFQ Calls Dashboard
  SAMAIRA_RFQ_CALLS: `${VOICE_AGENT_URL}/samaira/rfq-calls`,
  SAMAIRA_INITIATE_WEBRTC: `${VOICE_AGENT_URL}/samaira/rfq-calls/initiate-webrtc`,
  SAMAIRA_DISCONNECT_WEBRTC: `${VOICE_AGENT_URL}/ws/samaira/disconnect`,
  SAMAIRA_RFQ_CALL_ANALYTICS: `${AI_UTILITY_BASE_URL}/api/ozonetel/samaira/rfq/call-analytics`,

  // Sahara Inbound WebRTC Simulator
  SAHARA_INBOUND_INITIATE_WEBRTC: `${VOICE_AGENT_URL}/sahara/inbound/initiate-webrtc`,
  SAHARA_INBOUND_DISCONNECT_WEBRTC: `${VOICE_AGENT_URL}/ws/sahara/disconnect`,

  // Dynamic Pricing APIs
  GET_DYNAMIC_PRICING_LIST: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/list`,
  GET_DYNAMIC_PRICING_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/`,
  CREATE_DYNAMIC_PRICING: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/create`,
  UPDATE_DYNAMIC_PRICING: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/update`,
  DELETE_DYNAMIC_PRICING: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/delete/`,
  GET_DYNAMIC_PRICING_FILTERS: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/filters`,
  SEARCH_DYNAMIC_PRICING: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/search`,
  BULK_UPLOAD_DYNAMIC_PRICING: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/bulk-upload`,
  SYNC_DP_META: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/sync-dp-meta`,
  GET_DYNAMIC_PRICING_HISTORY: `${CMS_API_BASE_URL}/cmsApi/v1/dynamicPricing/history`,
  DOWNLOAD_RETURN_EXCHANGE_REPORT: `${AI_UTILITY_BASE_URL}/api/reports/return-exchange-requests`,

  GET_SERVICE_WARRANTIES: `${CMS_READ_BASE_URL}/cmsread/service-warranty`,
  GET_SERVICE_WARRANTY_BY_ID: `${CMS_READ_BASE_URL}/cmsread/service-warranty/`,
  UPSERT_SERVICE_WARRANTY: `${CMS_READ_BASE_URL}/cmsread/service-warranty`,
  GET_CLAIMED_WARRANTIES: `${CMS_READ_BASE_URL}/cmsread/user-service-warranty`,

  GET_WARRANTY_CLAIMS: `${CMS_READ_BASE_URL}/cmsread/warranty-claim`,
  GET_WARRANTY_CLAIM_BY_TICKET_ID: `${CMS_READ_BASE_URL}/cmsread/warranty-claim/`,
  GET_WARRANTY_CLAIM_NEXT_STAGES: `${CMS_READ_BASE_URL}/cmsread/warranty-claim/`,
  MOVE_WARRANTY_CLAIM_STAGE: `${CMS_READ_BASE_URL}/cmsread/warranty-claim/`,

  // Shipping Portal APIs
  GET_SHIPPING_RULES: `${CMS_API_BASE_URL}/cmsApi/v1/shipment/getShippingAttributesByPriority?type=all`,
  GET_SHIPPING_RULE_BY_ID: `${CMS_API_BASE_URL}/cmsApi/v1/shipment/getShippingCriteria`,
  CREATE_SHIPPING_RULE: `${CMS_API_BASE_URL}/cmsApi/v1/shipment/addShippingCriteria`,
  UPDATE_SHIPPING_RULE: `${CMS_API_BASE_URL}/cmsApi/v1/shipment/updateShippingCriteria`,
  GET_SHIPPING_CATEGORY_LEVEL_ONE: `${CMS_API_BASE_URL}/cmsApi/v1/shipment/getCategoryLevelOne`,
  EXPORT_SHIPPING_RULES: `${CMS_API_BASE_URL}/cmsApi/v1/shipment/exportShippingAmount`,
  UPLOAD_SHIPPING_BULK: `${CMS_API_BASE_URL}/cmsApi/v1/shipment/bulkUploadShipping`,
};
